export var ChipTypeTokens;
(function (ChipTypeTokens) {
    ChipTypeTokens["SMALL_SELECTED"] = "SMALL_SELECTED";
    ChipTypeTokens["SMALL_UNSELECTED"] = "SMALL_UNSELECTED";
    ChipTypeTokens["MEDIUM_SELECTED"] = "MEDIUM_SELECTED";
    ChipTypeTokens["MEDIUM_UNSELECTED"] = "MEDIUM_UNSELECTED";
})(ChipTypeTokens || (ChipTypeTokens = {}));
